import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import { LoginService } from "../login/login.service";

@Injectable()
export class AuthGuard implements CanActivate {
  // 注入 loginService 和 router
  constructor(private loginService: LoginService, private router: Router) {}

  // 实现canActivate函数
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    /**
     * 下面的代码打印路由
     */
    console.log(
      `即将被激活的路由:${next};即将到达的状态：${state};用户来自的URL：${
        state.url
      }`
    );
    if (this.loginService.isLoggedIn) {
      return true;
    }
    // 未登录跳转到login路由
    // this.router.navigateByUrl("user/login");

    return false;
  }

  checkLogin() {}
}
